import { path, propOr } from 'ramda';
import { createSelector } from 'reselect';

import { EMPTY_VALUES } from 'constants/general';

import { NAME } from './constants';

export const getRoot = path([NAME]);

export const getFeedbackData = createSelector(
	getRoot,
	(state, taskTypeId) => taskTypeId,
	(feedbackState, taskTypeId) => {
		return propOr(EMPTY_VALUES.OBJECT, taskTypeId)(feedbackState);
	},
);

export default getFeedbackData;
